/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext } from 'react'
import { Login } from './Login'
import { useDispatch } from 'react-redux';
import * as auth from '../redux/AuthRedux'
import { useHistory } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { TwoFactorMethod } from '../../../../app/modules/common/enum/two-factor-method'
export function LoginPage() {

  const dispatch = useDispatch()
  const history = useHistory();

  const { setEmail, setToken, setTwoFactorMethod } = useContext(AuthContext);


  const handleLogin = (token: string | undefined, email: string, twoFactorEnabled: boolean | null, twoFactorConnected: boolean,
    twoFactorMethod: number | 0) => {
    setEmail(email);
    setToken(token ?? '');
    setTwoFactorMethod(twoFactorMethod)

    if (twoFactorEnabled === null) {
      if (token) {
        dispatch(auth.actions.login(token))
      }
      return;
    }

    if (twoFactorEnabled === true) {
      if (twoFactorConnected === true || twoFactorMethod === TwoFactorMethod.Email) {
        history.push('/auth/login-2fa');
        return;
      }
      history.push('/auth/setup-2fa')
      return;
    }

    if (twoFactorEnabled === false) {
      history.push('/auth/option-2fa');
      return;
    }
  }

  return (<Login handleLogin={handleLogin} />);
}
